<template>
  <el-breadcrumb class="breadcrumb-container" separator="/">
    <el-breadcrumb-item v-for="item in list" :key="item.path">
      <span
        :class="{
          'is-active': $route.meta.title == item.meta.title,
        }"
      >
        {{ item.meta.title }}
      </span>
    </el-breadcrumb-item>
  </el-breadcrumb>
</template>

<script>
  export default {
    name: 'HtBreadcrumb',
    data() {
      return {
        list: [],
      }
    },
    watch: {
      $route: {
        handler() {
          this.list = this.$route.matched.filter(
            (item) => item.name && item.meta.title
          )
        },
        immediate: true,
      },
    },
  }
</script>

<style lang="scss" scoped>
  .is-active {
    font-weight: bold;
    color: #161616;
  }

  .breadcrumb-container {
    height: $base-nav-bar-height;
    font-size: $base-font-size-default;
    line-height: $base-nav-bar-height;

    ::v-deep {
      .el-breadcrumb__item {
        .el-breadcrumb__separator {
          margin: 0 12px;
          color: #c9cdd4;
        }

        .el-breadcrumb__inner {
          color: #8f99ac;

          a {
            display: flex;
            float: left;
            font-weight: normal;

            i {
              margin-right: 3px;
            }
          }
        }

        &:last-child {
          .el-breadcrumb__inner {
            color: var(--topColor);
          }
        }
      }
    }
  }
</style>
